import { render, staticRenderFns } from "./BarChartIcon.vue?vue&type=template&id=3c0b2001&"
import script from "./BarChartIcon.vue?vue&type=script&lang=js&"
export * from "./BarChartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports